import type { Options } from "./_model";

export default {
  info: {
    id: "Designathon",
  },
} satisfies Options;
